import {Injectable, signal} from "@angular/core";
import {
    CourseTypeService,
    ERPDataService, FilesService, GlobalSettingsService,
    MealPlanModelService,
    MenuLineService, MenuPlanRolloverPeriodService,
    MenuPlanService,
    SecurityService,
} from "@menu-api";
import {getContextKey} from "../api/api-helper";
import {API_CALLS} from "../constants";

export const API_ERROR_MESSAGES = {
    [getContextKey(FilesService.name, API_CALLS.API_LOAD)]: {translationKey: "error.api.file.names"},
    [getContextKey(FilesService.name, API_CALLS.API_FILE_DOWNLOAD)]: {translationKey: "error.api.file.download"},
    [getContextKey(FilesService.name, API_CALLS.API_SAVE)]: {translationKey: "error.api.file.upload"},
    [getContextKey(FilesService.name, API_CALLS.API_DELETE)]: {translationKey: "error.api.file.delete"},
    [getContextKey(MenuLineService.name, API_CALLS.API_LOAD)]: {translationKey: "error.api.menulines"},
    [getContextKey(MenuLineService.name, API_CALLS.API_SAVE)]: {translationKey: "error.api.save.menulines"},
    [getContextKey(MenuLineService.name, API_CALLS.API_DELETE)]: {translationKey: "error.api.delete.menulines"},
    [getContextKey(MenuPlanService.name, API_CALLS.API_DELETE)]: {translationKey: "error.api.delete.menuplan"},
    [getContextKey(MenuPlanService.name, API_CALLS.API_LOAD)]: {translationKey: "error.api.menuplan"},
    [getContextKey(MenuPlanService.name, API_CALLS.API_LIST_LOAD)]: {translationKey: "error.api.menuplan-list"},
    [getContextKey(MenuPlanService.name, API_CALLS.API_SAVE)]: {translationKey: "error.api.save.menuplan"},
    [getContextKey(MenuLineService.name, API_CALLS.API_UPDATE)]: {translationKey: "error.api.update.menucourse"},
    [getContextKey(MenuLineService.name, API_CALLS.VALIDATE)]: {translationKey: "error.api.validate.menuline"},
    [getContextKey(MealPlanModelService.name, API_CALLS.INIT_MEAL_PLAN_MODEL)]: {translationKey: "error.api.save.model-new"},
    [getContextKey(MealPlanModelService.name, API_CALLS.DUPLICATE_MEAL_PLAN_MODEL)]: {translationKey: "error.api.save.model-duplicate"},
    [getContextKey(ERPDataService.name, API_CALLS.API_LOAD)]: {translationKey: "error.api.erp.article"},
    [getContextKey(SecurityService.name, API_CALLS.API_LOAD)]: {translationKey: "error.api.users"},
    [getContextKey(MealPlanModelService.name, API_CALLS.API_UPDATE_USER_ASSIGNMENT)]: {translationKey: "error.api.update.user-assignment"},
    [getContextKey(MenuPlanService.name, API_CALLS.MENU_PLAN_FINISH)]: {translationKey: "error.api.save.menuplan-finish"},
    [getContextKey(MenuPlanService.name, API_CALLS.MENU_PLAN_REOPEN)]: {translationKey: "error.api.save.menuplan-reopen"},
    [getContextKey(CourseTypeService.name, API_CALLS.API_LIST_LOAD)]: {translationKey: "error.api.coursetype-list"},
    [getContextKey(CourseTypeService.name, API_CALLS.API_LOAD)]: {translationKey: "error.api.coursetype"},
    [getContextKey(MenuPlanRolloverPeriodService.name, API_CALLS.API_COPY)]: {translationKey: "error.api.copy.planning"},
    [getContextKey(CourseTypeService.name, API_CALLS.API_SAVE)]: {translationKey: "error.api.save.course"},
    [getContextKey(CourseTypeService.name, API_CALLS.API_UPDATE)]: {translationKey: "error.api.update.course"},
    [getContextKey(CourseTypeService.name, API_CALLS.API_DELETE)]: {translationKey: "error.api.delete.course"},
    [getContextKey(GlobalSettingsService.name, API_CALLS.API_LIST_LOAD)]: {translationKey: "error.api.global-settings"},
    [getContextKey(GlobalSettingsService.name, API_CALLS.API_UPDATE)]: {translationKey: "error.api.save.global-settings"},
};

export type ErrorMessage = { translationKey: string } | ({ translationKey: undefined } & string);

@Injectable({providedIn: "root"})
export class ErrorService {
    public readonly errorSignal = signal<ErrorMessage | null>(null);

    public setError(api: string): void {
        this.errorSignal.set(API_ERROR_MESSAGES[api] ?? {translationKey: "error.api.default"});
    }

    public cleanError(): void {
        this.errorSignal.set(null);
    }
}
